
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Historial.css";
import API from "../api";

const Historial = () => {
  const navigate = useNavigate();

  const [movimientos, setMovimientos] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const obtenerHistorial = async () => {
      try {
        const token = sessionStorage.getItem("token");

        if (!token) {
          throw new Error(
            "No se encontró una sesión activa. Inicia sesión nuevamente."
          );
        }

        const respuesta = await fetch(
  `${API}/historial`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const datos = await respuesta.json();

        if (!respuesta.ok) {
          throw new Error(
            datos.error || "No se pudo obtener el historial"
          );
        }

        setMovimientos(datos);
      } catch (err) {
        setError(err.message);
      } finally {
        setCargando(false);
      }
    };

    obtenerHistorial();
  }, []);

  const formatoMoneda = (monto) => {
    return `Q${Number(monto).toFixed(2)}`;
  };

  const formatoFecha = (fecha) => {
    if (!fecha) return "Sin fecha";

    const fechaConvertida = new Date(fecha);

    if (Number.isNaN(fechaConvertida.getTime())) {
      return "Fecha no disponible";
    }

    return fechaConvertida.toLocaleString("es-GT", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const claseEstado = (estado) => {
    const clases = {
      Pendiente: "historial-pendiente",
      Aprobada: "historial-aprobada",
      Rechazada: "historial-rechazada",
      Entregada: "historial-entregada",
    };

    return clases[estado] || "";
  };


return (
  <div className="historial-container">


<div className="boton-volver-superior">
  <button
    type="button"
    className="boton-volver-dashboard"
    onClick={() => navigate("/dashboard")}
  >
    ← Volver al Dashboard
  </button>
</div>


    <h1 className="historial-titulo">
      Historial de viáticos
    </h1>


      <p className="historial-subtitulo">
        Consulta las solicitudes y liquidaciones registradas
        en Transportes Figueroa.
      </p>

      {cargando && (
        <p className="historial-mensaje">
          Cargando historial...
        </p>
      )}

      {error && (
        <p className="historial-error" role="alert">
          {error}
        </p>
      )}

      {!cargando && !error && (
        <div className="historial-tabla-contenedor">
          <table className="historial-tabla">
            <thead>
              <tr>
                <th>ID</th>
                <th>Conductor</th>
                <th>Tipo</th>
                <th>Detalles</th>
                <th>Monto</th>
                <th>Estado</th>
                <th>Fecha</th>
              </tr>
            </thead>

            <tbody>
              {movimientos.length > 0 ? (
                movimientos.map((m) => (
                  <tr key={`${m.tipo}-${m.id}`}>
                    <td>#{m.id}</td>

                    <td>{m.conductor}</td>

                    <td>
                      <span className="historial-tipo">
                        {m.tipo}
                      </span>
                    </td>

                    <td>{m.detalles}</td>

                    <td>
                      <span className="historial-monto">
                        {formatoMoneda(m.monto)}
                      </span>
                    </td>

                    <td>
                      <span
                        className={`historial-estado ${claseEstado(
                          m.estado
                        )}`}
                      >
                        {m.estado}
                      </span>
                    </td>

                    <td>{formatoFecha(m.fecha)}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7" className="historial-mensaje">
                    No hay solicitudes ni liquidaciones
                    registradas.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default Historial;
